/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyWheel.vue?vue&type=template&id=07ed12ce"
import script from "./luckyWheel.vue?vue&type=script&lang=js"
export * from "./luckyWheel.vue?vue&type=script&lang=js"
import style0 from "./luckyWheel.vue?vue&type=style&index=0&id=07ed12ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports